<template>
  <div class="tw-space-y-3">
    <div>
      <img
        :src="cropObject.imageUrl == '' ? ' ' : cropObject.imageUrl"
        ref="photoElement"
        @load="onImageLoaded"
        style="max-width: 100%;"
      />
    </div>
    <div class="ts-flex ts-justify-end ts-space-x-3 ts-mt-3">
      <ts-button color="primary" outline :waiting="cropping" @click="cropPhoto">
        <i class="fas fa-crop"></i> {{ $t('crop') }}
      </ts-button>
      <ts-button 
        color="primary" outline 
        :waiting="cropping" 
        @click="$emit('retake')"
        v-if="takeAgain"
      >
        <i class="fas fa-camera"></i> {{ $t('takePhoto') }}
      </ts-button>
    </div>
  </div>
</template>

<script>
import Cropper from 'cropperjs'

export default {
  props: ['width', 'height', 'cropObject', 'takeAgain'],
  data() {
    return {
      cropper: null,
      cropping: false
    }
  },
  methods: {
    onImageLoaded() {
      if (this.cropper !== null) this.cropper.destroy()

      this.cropper = new Cropper(this.$refs.photoElement, {
        viewMode: 1,
        dragMode: 'move',
        aspectRatio: this.width / this.height,
        autoCropArea: 0,
        restore: false,
        guides: false,
        center: false,
        highlight: false,
        cropBoxMovable: true,
        cropBoxResizable: true,
        toggleDragModeOnDblclick: false,
        minContainerWidth: this.width ? this.width : 200,
        minContainerHeight: this.height ? this.height : 100
      })
    },
    cropPhoto() {
      this.cropping = true
      this.cropObject.canvas = this.cropper.getCroppedCanvas()
      this.cropping = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
@import '~cropperjs/dist/cropper.css';
</style>
